// Broselow-Luten tape zones
export const BROSELOW_ZONES = [
  {
    code: "grey",
    label: "GREY",
    hex: "#868E96",
    textClass: "text-white",
    weightLabel: "3–5 kg",
    heightLabel: "46–57 cm",
    minKg: 3, maxKg: 5, medianKg: 4,
    age: "Neonate",
    ett: "3.0–3.5 unc",
    ettDepth: "9–10 cm",
    blade: "Str 0–1",
    lma: "1",
    defib: "4 J/kg",
  },
  {
    code: "pink",
    label: "PINK",
    hex: "#F06595",
    textClass: "text-white",
    weightLabel: "6–7 kg",
    heightLabel: "57–70 cm",
    minKg: 6, maxKg: 7, medianKg: 6.5,
    age: "~3–6 mo",
    ett: "3.5 unc/cuf",
    ettDepth: "10–11 cm",
    blade: "Str 1",
    lma: "1.5",
    defib: "4 J/kg",
  },
  {
    code: "red",
    label: "RED",
    hex: "#E03131",
    textClass: "text-white",
    weightLabel: "8–9 kg",
    heightLabel: "70–80 cm",
    minKg: 8, maxKg: 9, medianKg: 8.5,
    age: "~6–12 mo",
    ett: "3.5–4.0",
    ettDepth: "11–12 cm",
    blade: "Str 1",
    lma: "1.5–2",
    defib: "4 J/kg",
  },
  {
    code: "purple",
    label: "PURPLE",
    hex: "#9C36B5",
    textClass: "text-white",
    weightLabel: "10–11 kg",
    heightLabel: "80–88 cm",
    minKg: 10, maxKg: 11, medianKg: 10.5,
    age: "~1–2 yr",
    ett: "4.0",
    ettDepth: "12–13 cm",
    blade: "Mac 2",
    lma: "2",
    defib: "4 J/kg",
  },
  {
    code: "yellow",
    label: "YELLOW",
    hex: "#FCC419",
    textClass: "text-black",
    weightLabel: "12–14 kg",
    heightLabel: "88–96 cm",
    minKg: 12, maxKg: 14, medianKg: 13,
    age: "~2–3 yr",
    ett: "4.5",
    ettDepth: "13–14 cm",
    blade: "Mac 2",
    lma: "2",
    defib: "4 J/kg",
  },
  {
    code: "white",
    label: "WHITE",
    hex: "#F1F3F5",
    textClass: "text-black",
    weightLabel: "15–18 kg",
    heightLabel: "96–108 cm",
    minKg: 15, maxKg: 18, medianKg: 16.5,
    age: "~3–5 yr",
    ett: "4.5–5.0",
    ettDepth: "14–15 cm",
    blade: "Mac 2",
    lma: "2",
    defib: "4 J/kg",
  },
  {
    code: "blue",
    label: "BLUE",
    hex: "#1971C2",
    textClass: "text-white",
    weightLabel: "19–23 kg",
    heightLabel: "108–120 cm",
    minKg: 19, maxKg: 23, medianKg: 21,
    age: "~5–7 yr",
    ett: "5.0–5.5",
    ettDepth: "15–17 cm",
    blade: "Mac 2–3",
    lma: "2.5",
    defib: "4 J/kg",
  },
  {
    code: "orange",
    label: "ORANGE",
    hex: "#F76707",
    textClass: "text-white",
    weightLabel: "24–29 kg",
    heightLabel: "120–131 cm",
    minKg: 24, maxKg: 29, medianKg: 26.5,
    age: "~7–9 yr",
    ett: "5.5–6.0",
    ettDepth: "17–19 cm",
    blade: "Mac 3",
    lma: "2.5–3",
    defib: "4 J/kg",
  },
  {
    code: "green",
    label: "GREEN",
    hex: "#2F9E44",
    textClass: "text-white",
    weightLabel: "30–36 kg",
    heightLabel: "131–143 cm",
    minKg: 30, maxKg: 36, medianKg: 33,
    age: "~10–12 yr",
    ett: "6.0–6.5 cuf",
    ettDepth: "19–21 cm",
    blade: "Mac 3",
    lma: "3",
    defib: "4 J/kg",
  },
];

export function zoneForWeight(w) {
  for (const z of BROSELOW_ZONES) {
    if (w >= z.minKg && w <= z.maxKg) return z;
  }
  if (w < BROSELOW_ZONES[0].minKg) return BROSELOW_ZONES[0];
  return { ...BROSELOW_ZONES[BROSELOW_ZONES.length - 1], label: "ADULT", code: "adult" };
}
